/** @jsx jsx */
import { jsx } from '@emotion/core';
import { ButtonTertiary, Heading } from '@americanexpress/dls-react';
import merge from 'deepmerge';
import PropTypes from 'prop-types';
import loaderStyle from '../../styles/Loader/LoaderCss';

const Loader = ({
  showLoader, theme, leadingTxt = 'Please wait...', displayIcon = null,
}) => {
  const styleObj = merge.all([loaderStyle, theme || {}]);
  return (
    <div
      id="export-loading"
      key="export-loading"
      style={{
        display: showLoader ? 'block' : 'none',
      }}
      css={styleObj['.loadingOverlay']}
    >
      <div css={styleObj['.loading']}>
        <Heading
          id="export-loading-header"
          level={4}
          headingStyle="heading3"
          css={styleObj['.loadingHeader']}
        >
          {leadingTxt}
        </Heading>

        <div style={{
          textAlign: 'center',
          minWidth: '11.25rem',
        }}
        >
          {displayIcon || (
          <ButtonTertiary
            id="export-loading-loader-icon"
            aria-label="Tertiary"
            loading={true}
            style={{
              cursor: 'none',
              pointerEvents: 'none',
            }}
          >Loading...
          </ButtonTertiary>
          )}
        </div>
      </div>
    </div>
  );
};

Loader.propTypes = {
  showLoader: PropTypes.bool,
  theme: PropTypes.shape({}),
  leadingTxt: PropTypes.string,
  displayIcon: PropTypes.element,
};

export default Loader;
